import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import logoNeuroResearch from "@/assets/logo-neuroresearch.webp";

const FooterEN = () => {
  return (
    <footer className="bg-card border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          <div>
            <Link to="/en" className="inline-block mb-4">
              <img 
                src={logoNeuroResearch} 
                alt="NeuroResearch Foundation" 
                width={179}
                height={48}
                loading="lazy"
                decoding="async"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Researching today to cure tomorrow. Dedicated to finding solutions 
              for the most challenging neurological diseases.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Research</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/en/research-projects" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Research & Projects</Link></li>
              <li><Link to="/en/collaborations" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Collaborations</Link></li>
              <li><Link to="/en/clinical-trials" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Clinical Trials</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Participate</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link 
                  to="/en" 
                  onClick={() => {
                    setTimeout(() => {
                      const donationSection = document.getElementById('donation-section');
                      if (donationSection) {
                        donationSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="hover:text-primary transition-colors"
                >
                  Donate
                </Link>
              </li>
              <li><Link to="/en/volunteering" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Volunteering</Link></li>
              <li><Link to="/en/events" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Events</Link></li>
              <li><Link to="/en/newsletter" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Newsletter</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Stay Informed</h4>
            <p className="text-muted-foreground mb-4">
              Subscribe to receive updates about our research
            </p>
            <div className="flex gap-2">
              <Button 
                variant="secondary"
                asChild
              >
                <Link to="/en/newsletter">Subscribe</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-muted-foreground">
              © 2024 Green Life Bcn Foundation. All rights reserved.
            </div>
            <div className="flex gap-6 text-muted-foreground">
              <Link to="/en/privacy" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Privacy</Link>
              <Link to="/en/terms" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Terms</Link>
              <Link to="/en/contact" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Contact</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterEN;
